<app-mb-card>
    <div [formGroup]="signInForm">
        <h3>Bienvenido</h3>
        <app-mb-field fullwidth>
            <input type="text" formControlName="email" placeholder="Email">
        </app-mb-field>
        <app-mb-field fullwidth>
            <input type="password" formControlName="password" placeholder="Contraseña">
        </app-mb-field>
        <div>
            <app-mb-button (click)="signIn()">Entrar</app-mb-button>
        </div>
    </div>
</app-mb-card>